import EarmarkAccountingApi from "@/api/earmark/earmarkAccounting";

export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async fetchReportData({dispatch}, form) {
      try {
        const response = await EarmarkAccountingApi.fetchReportData(form);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async save({dispatch}, form) {
      try {
        const response = await EarmarkAccountingApi.save(form);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
